import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { PropertiesSettings } from "../../core/configuration/properties-settings";
import { ServicePathsSettings } from '../../core/configuration/service-paths-settings';
import { ModalNotifyService } from '../../core/services/modal-notify.service';
import { OperationsService } from '../../core/services/operations.service';
import { SearchTextComponent } from '../components/input-component/searchText/search-text.component';
import { Anagrafica } from '../models/anagrafica';
import { SearchAnagraficheResponse } from '../models/dto/search-anagrafiche-response';
import { BaseForm } from './base-Form';

declare var $: any;


@Component({
  selector: 'div [ricerca-anagrafiche-form]',
  templateUrl: 'ricerca-anagrafiche-form.html'
})

export class RicercaAnagraficheFormComponent<T extends Anagrafica> extends BaseForm {
  readonly PROPERTIES_SETTINGS = PropertiesSettings;
  requestUrl: string;
  optionsList: { hasDetailsAnagrafica: boolean, anagrafica: T }[] = [];
  isPartiSearch: boolean;
  isConcatSearch: boolean = false;
  waitResponseSearch: boolean = false;
  msgEmpty: string;
  totali: number;
  operationIndex: number;

  @Input() isLegale: boolean = false;
  @Input() isParte: boolean = false;
  @Input() isAmministrazioneModule: boolean = false;
  @Input() isControparte: boolean = false;
  isPrd: boolean = PropertiesSettings.ID_TENANTS_PRD();
  @ViewChild('searchElement', {static: true}) searchElement: SearchTextComponent;
  @Output() onReturn: EventEmitter<T> = new EventEmitter<T>();
  @Input() labelButton: string = 'Associa';
  @Output() onClickDisable: EventEmitter<T> = new EventEmitter<T>();
  @Output() onClickAbilita: EventEmitter<T> = new EventEmitter<T>();

  constructor(private operations: OperationsService, private modalNotifyService: ModalNotifyService) {
    super();
  }

  public inizializza(requestUrl: string, isPartiSearch: boolean, isAmministrazioneModule: boolean = false) {
    this.searchElement.fromResult = 0;
    this.requestUrl = requestUrl;
    this.isAmministrazioneModule = isAmministrazioneModule;
    this.isPartiSearch = isPartiSearch;
    if (this.searchElement) {
      this.searchElement.setTextEmpty();
    }
    let model = this;
    $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
      if (model.searchElement) {
        model.searchElement.setTextEmpty();
      }
    });
    if (!!isAmministrazioneModule) {
      this.searchElement.initSearch(this.requestUrl);
    }
  }

  private associa(option: { hasDetailsAnagrafica: boolean, anagrafica: T }, indice: number) {
    if (option.hasDetailsAnagrafica) {
      this.onReturn.emit(option.anagrafica);
    } else {
      this.getAnagrafica(option.anagrafica).subscribe(response => this.associa(this.refreshElementInArray(indice, response), indice));
    }
  }

  private generaDoc(anagrafica: T) {
    this.operations.getAllTipiEntita().subscribe(res => {
      if (res) {
        const objEntity = this.isLegale ? res.find(el => el.anagrafica === 'legale') : res.find(el => el.anagrafica === 'parte');
        if (objEntity) {
          this.operations.getTemplatesByEntity(objEntity.id).subscribe(response => {
            if (response && response.length > 0) {
              const objDoc = {
                tipoAnagrafica: this.isLegale ? 'legale' : 'parte',
                idAnagrafica: anagrafica.id,
                idTemplate: response[0].idTemplate
              };
              this.operations.generaDocumentoAnagrafica(objDoc).subscribe();
              // this.operations.generaDoc(objDoc).subscribe(re => {
              //   UtilityCommon.downloadFile(re);
              // });
            } else {
              this.modalNotifyService.customMessage('Nessun template associato al tipo anagrafica');
            }
          });
        }
      }
    });
  }

  prendiDettagliAnagrafica(option: { hasDetailsAnagrafica: boolean, anagrafica: T }, indice: number) {
    if (!option.hasDetailsAnagrafica) {
      this.getAnagrafica(option.anagrafica).subscribe(response => this.refreshElementInArray(indice, response));
    }
  }

  private refreshElementInArray(indice: number, element: T): { hasDetailsAnagrafica: boolean, anagrafica: T } {
    this.optionsList[indice].hasDetailsAnagrafica = true;
    this.optionsList[indice].anagrafica = element;
    return this.optionsList[indice];
  }

  refreshAfterOperation(option) {
    this.getAnagrafica(option).subscribe(response => this.refreshElementInArray(this.operationIndex, response));
  }

  private getAnagrafica(option: T): Observable<T> {
    return this.operations.getAnagrafica(this.isPartiSearch ? ServicePathsSettings.URL_GET_PARTE : ServicePathsSettings.URL_GET_LEGALE, option.id, this.isPartiSearch);
  }

  public refresh(response: SearchAnagraficheResponse) {
    if (response && response.numeroAnagTotali) {
      this.totali = response.numeroAnagTotali;
    } else {
      this.totali = 0;
    }
    if (!this.isConcatSearch) {
      this.optionsList = [];
    }
    let listaFiltrata: T[] = [];
    if (response && <T[]>response.anagrafiche) {
      listaFiltrata = <T[]>response.anagrafiche;
      this.msgEmpty = '';
      for (let element of listaFiltrata) {
        this.optionsList.push({ hasDetailsAnagrafica: false, anagrafica: element });
      }
    } else {
      this.msgEmpty = 'La ricerca non ha prodotto risultati';
    }
    this.isConcatSearch = false;
    this.waitResponseSearch = false;
  }

  public setTextEmpty() {
    if (this.searchElement) {
      this.searchElement.setTextEmpty();
    }
  }

  resetResults() {
    this.optionsList = [];  // Ripulisce la lista dei risultati della ricerca
  }

  reloadSearch() {
    this.searchElement.fromResult = this.optionsList.length;
    this.isConcatSearch = true;
    this.waitResponseSearch = true;
    this.searchElement.manageValue(true);
  }

  disableParte(anagrafica: T, indice: number) {
    this.operationIndex = indice;
    this.onClickDisable.emit(anagrafica);
  }

  actionCallback(response) {
    if (response.returnCode === "OK")
      this.searchElement.manageValue();
  }

  enableParte(anagrafica: T, indice: number) {
    this.operationIndex = indice;
    this.onClickAbilita.emit(anagrafica);
  }
}
